// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PanelLayout.module.css — estilos compartidos para todas las vistas del panel de usuario */

.PanelLayout_panelPage__itt\\+b {
  display: flex;
  min-height: 100vh;
  background: #f0f4f8;
}

/* ══════════════════════════════════════
   SIDEBAR
══════════════════════════════════════ */
.PanelLayout_sidebar__ak-RO {
  width: 220px;
  min-width: 220px;
  background: #1a3a5c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 28px 0 20px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.PanelLayout_sidebarTop__9MhHT {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 8px;
}

.PanelLayout_avatar__dFXo8 {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2db899;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.PanelLayout_avatarImg__tiXxC {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 12px;
}

.PanelLayout_userName__lX6Ls {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 2px;
}

.PanelLayout_userEmail__kz--s {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
  margin-bottom: 12px;
  word-break: break-all;
}

.PanelLayout_lastConsult__BOBiY {
  background: rgba(45, 184, 153, 0.2);
  border: 1px solid rgba(45, 184, 153, 0.4);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  color: #2db899;
  font-weight: 600;
  text-align: center;
}

.PanelLayout_menuLabel__kYPK3 {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.35);
  padding: 0 20px;
  margin-bottom: 6px;
  margin-top: 4px;
}

.PanelLayout_menuList__74tI1 {
  list-style: none;
  padding: 0;
  margin: 0;
}

.PanelLayout_menuItem__Oqkhc {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  border-left: 3px solid transparent;
  text-decoration: none;
  transition:
    background 0.15s,
    color 0.15s;
}

.PanelLayout_menuItem__Oqkhc:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.PanelLayout_menuItemActive__lT4\\+O {
  background: rgba(45, 184, 153, 0.15);
  border-left-color: #2db899;
  color: #fff;
  font-weight: 600;
}

.PanelLayout_sidebarBottom__Wp5nB {
  padding: 20px;
}

.PanelLayout_btnLogout__vLgic {
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    border-color 0.2s,
    color 0.2s;
}

.PanelLayout_btnLogout__vLgic:hover {
  border-color: #fda29b;
  color: #fda29b;
}

/* ══════════════════════════════════════
   MAIN
══════════════════════════════════════ */
.PanelLayout_main__x7iEZ {
  flex: 1 1;
  padding: 32px 28px;
  overflow-y: auto;
}

.PanelLayout_mainHeader__0yW\\+I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.PanelLayout_mainHeaderLeft__WRIsH p {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 2px;
}

.PanelLayout_mainHeaderLeft__WRIsH h1 {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a3a5c;
  margin: 0;
}

.PanelLayout_mainHeaderRight__jZp3F {
  display: flex;
  align-items: center;
  gap: 12px;
}

.PanelLayout_bellBtn__wL-Pl {
  background: #fff;
  border: 1.5px solid #e4e7ec;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667085;
}

.PanelLayout_headerAvatar__lIqCQ {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #2db899;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ══ Card genérica ══ */
.PanelLayout_card__ONTEU {
  background: #fff;
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.PanelLayout_cardHeader__i8jcW {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.PanelLayout_cardTitle__eur91 {
  font-size: 15px;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0;
}

/* ══ Badges ══ */
.PanelLayout_badgeTele__mdvWm {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeDomicilio__DxCDs {
  background: #fff8ec;
  color: #d97706;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgePresencial__ax9mc {
  background: #eff8ff;
  color: #1a6bcc;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeConfirmada__wbGt2 {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgePendiente__5jU80 {
  background: #fff8ec;
  color: #d97706;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeCompletada__\\+LWrO {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeCancelada__yWazF {
  background: #fff1f0;
  color: #d92d20;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeActiva__S7Vxk {
  background: #e6f7f3;
  color: #2db899;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}
.PanelLayout_badgeVencida__FpKHW {
  background: #f2f4f7;
  color: #98a2b3;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.PanelLayout_emptyState__yFutT {
  text-align: center;
  padding: 32px 0;
  color: #98a2b3;
  font-size: 14px;
}

/* ══ Stats row ══ */
.PanelLayout_statsGrid__se\\+zj {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.PanelLayout_statCard__8AXK9 {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.PanelLayout_statValue__db4eP {
  font-size: 1.6rem;
  font-weight: 800;
  color: #1a3a5c;
  line-height: 1;
  margin-bottom: 4px;
}
.PanelLayout_statValue__db4eP.PanelLayout_teal__7VF\\+Q {
  color: #2db899;
}
.PanelLayout_statValue__db4eP.PanelLayout_orange__-t3cY {
  color: #f59e0b;
}
.PanelLayout_statTitle__v01VA {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 2px;
}
.PanelLayout_statSub__\\+1yls {
  font-size: 11px;
  color: #98a2b3;
}

/* ══ Responsive ══ */
@media (max-width: 900px) {
  .PanelLayout_sidebar__ak-RO {
    display: none;
  }
  .PanelLayout_statsGrid__se\\+zj {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ══ Quick Actions ══ */
.PanelLayout_quickActions__OV--4 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.PanelLayout_quickAction__hCcwl {
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1.5px solid #e4e7ec;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s;
}

.PanelLayout_quickAction__hCcwl:hover {
  border-color: #2db899;
  background: #f0fdf9;
}

.PanelLayout_quickActionPrimary__DkmeW {
  background: #e6f7f3;
  border-color: #2db899;
}

.PanelLayout_quickActionTitle__JFhOf {
  font-size: 13px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 2px;
}

.PanelLayout_quickActionPrimary__DkmeW .PanelLayout_quickActionTitle__JFhOf {
  color: #2db899;
}

.PanelLayout_quickActionSub__j9X75 {
  font-size: 11px;
  color: #98a2b3;
}

.PanelLayout_orange__-t3cY {
  color: #f59e0b;
}
`, "",{"version":3,"sources":["webpack://./src/components/PanelUser/PanelLayout.module.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB;;eAEa;AACf;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;cAEY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* PanelLayout.module.css — estilos compartidos para todas las vistas del panel de usuario */\n\n.panelPage {\n  display: flex;\n  min-height: 100vh;\n  background: #f0f4f8;\n}\n\n/* ══════════════════════════════════════\n   SIDEBAR\n══════════════════════════════════════ */\n.sidebar {\n  width: 220px;\n  min-width: 220px;\n  background: #1a3a5c;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 28px 0 20px;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.sidebarTop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 8px;\n}\n\n.avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #2db899;\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.avatarImg {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 12px;\n}\n\n.userName {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.userEmail {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.55);\n  text-align: center;\n  margin-bottom: 12px;\n  word-break: break-all;\n}\n\n.lastConsult {\n  background: rgba(45, 184, 153, 0.2);\n  border: 1px solid rgba(45, 184, 153, 0.4);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 10px;\n  color: #2db899;\n  font-weight: 600;\n  text-align: center;\n}\n\n.menuLabel {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.35);\n  padding: 0 20px;\n  margin-bottom: 6px;\n  margin-top: 4px;\n}\n\n.menuList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  border-left: 3px solid transparent;\n  text-decoration: none;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.menuItem:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n.menuItemActive {\n  background: rgba(45, 184, 153, 0.15);\n  border-left-color: #2db899;\n  color: #fff;\n  font-weight: 600;\n}\n\n.sidebarBottom {\n  padding: 20px;\n}\n\n.btnLogout {\n  width: 100%;\n  padding: 10px;\n  background: transparent;\n  border: 1.5px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    color 0.2s;\n}\n\n.btnLogout:hover {\n  border-color: #fda29b;\n  color: #fda29b;\n}\n\n/* ══════════════════════════════════════\n   MAIN\n══════════════════════════════════════ */\n.main {\n  flex: 1;\n  padding: 32px 28px;\n  overflow-y: auto;\n}\n\n.mainHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.mainHeaderLeft p {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 2px;\n}\n\n.mainHeaderLeft h1 {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  margin: 0;\n}\n\n.mainHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.bellBtn {\n  background: #fff;\n  border: 1.5px solid #e4e7ec;\n  border-radius: 50%;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #667085;\n}\n\n.headerAvatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #2db899;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ══ Card genérica ══ */\n.card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 22px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n  margin-bottom: 16px;\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.cardTitle {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0;\n}\n\n/* ══ Badges ══ */\n.badgeTele {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeDomicilio {\n  background: #fff8ec;\n  color: #d97706;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgePresencial {\n  background: #eff8ff;\n  color: #1a6bcc;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeConfirmada {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgePendiente {\n  background: #fff8ec;\n  color: #d97706;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeCompletada {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeCancelada {\n  background: #fff1f0;\n  color: #d92d20;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeActiva {\n  background: #e6f7f3;\n  color: #2db899;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.badgeVencida {\n  background: #f2f4f7;\n  color: #98a2b3;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 32px 0;\n  color: #98a2b3;\n  font-size: 14px;\n}\n\n/* ══ Stats row ══ */\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.statCard {\n  background: #fff;\n  border-radius: 12px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n}\n\n.statValue {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n.statValue.teal {\n  color: #2db899;\n}\n.statValue.orange {\n  color: #f59e0b;\n}\n.statTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #344054;\n  margin-bottom: 2px;\n}\n.statSub {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n/* ══ Responsive ══ */\n@media (max-width: 900px) {\n  .sidebar {\n    display: none;\n  }\n  .statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ══ Quick Actions ══ */\n.quickActions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quickAction {\n  display: flex;\n  flex-direction: column;\n  padding: 14px 16px;\n  border-radius: 10px;\n  background: #f9fafb;\n  border: 1.5px solid #e4e7ec;\n  text-decoration: none;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.quickAction:hover {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n.quickActionPrimary {\n  background: #e6f7f3;\n  border-color: #2db899;\n}\n\n.quickActionTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 2px;\n}\n\n.quickActionPrimary .quickActionTitle {\n  color: #2db899;\n}\n\n.quickActionSub {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n.orange {\n  color: #f59e0b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelPage": `PanelLayout_panelPage__itt+b`,
	"sidebar": `PanelLayout_sidebar__ak-RO`,
	"sidebarTop": `PanelLayout_sidebarTop__9MhHT`,
	"avatar": `PanelLayout_avatar__dFXo8`,
	"avatarImg": `PanelLayout_avatarImg__tiXxC`,
	"userName": `PanelLayout_userName__lX6Ls`,
	"userEmail": `PanelLayout_userEmail__kz--s`,
	"lastConsult": `PanelLayout_lastConsult__BOBiY`,
	"menuLabel": `PanelLayout_menuLabel__kYPK3`,
	"menuList": `PanelLayout_menuList__74tI1`,
	"menuItem": `PanelLayout_menuItem__Oqkhc`,
	"menuItemActive": `PanelLayout_menuItemActive__lT4+O`,
	"sidebarBottom": `PanelLayout_sidebarBottom__Wp5nB`,
	"btnLogout": `PanelLayout_btnLogout__vLgic`,
	"main": `PanelLayout_main__x7iEZ`,
	"mainHeader": `PanelLayout_mainHeader__0yW+I`,
	"mainHeaderLeft": `PanelLayout_mainHeaderLeft__WRIsH`,
	"mainHeaderRight": `PanelLayout_mainHeaderRight__jZp3F`,
	"bellBtn": `PanelLayout_bellBtn__wL-Pl`,
	"headerAvatar": `PanelLayout_headerAvatar__lIqCQ`,
	"card": `PanelLayout_card__ONTEU`,
	"cardHeader": `PanelLayout_cardHeader__i8jcW`,
	"cardTitle": `PanelLayout_cardTitle__eur91`,
	"badgeTele": `PanelLayout_badgeTele__mdvWm`,
	"badgeDomicilio": `PanelLayout_badgeDomicilio__DxCDs`,
	"badgePresencial": `PanelLayout_badgePresencial__ax9mc`,
	"badgeConfirmada": `PanelLayout_badgeConfirmada__wbGt2`,
	"badgePendiente": `PanelLayout_badgePendiente__5jU80`,
	"badgeCompletada": `PanelLayout_badgeCompletada__+LWrO`,
	"badgeCancelada": `PanelLayout_badgeCancelada__yWazF`,
	"badgeActiva": `PanelLayout_badgeActiva__S7Vxk`,
	"badgeVencida": `PanelLayout_badgeVencida__FpKHW`,
	"emptyState": `PanelLayout_emptyState__yFutT`,
	"statsGrid": `PanelLayout_statsGrid__se+zj`,
	"statCard": `PanelLayout_statCard__8AXK9`,
	"statValue": `PanelLayout_statValue__db4eP`,
	"teal": `PanelLayout_teal__7VF+Q`,
	"orange": `PanelLayout_orange__-t3cY`,
	"statTitle": `PanelLayout_statTitle__v01VA`,
	"statSub": `PanelLayout_statSub__+1yls`,
	"quickActions": `PanelLayout_quickActions__OV--4`,
	"quickAction": `PanelLayout_quickAction__hCcwl`,
	"quickActionPrimary": `PanelLayout_quickActionPrimary__DkmeW`,
	"quickActionTitle": `PanelLayout_quickActionTitle__JFhOf`,
	"quickActionSub": `PanelLayout_quickActionSub__j9X75`
};
export default ___CSS_LOADER_EXPORT___;
